import React, { useState } from "react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { httpBatchLink } from "@trpc/client";
import { trpc } from "./trpc";
const API_URL = location.hostname === "localhost"
    ? "http://localhost:3000"
    : "https://api.tictactoe.mattb.tech";
export const QueryProvider = ({ children, }) => {
    const [queryClient] = useState(() => new QueryClient());
    const [trpcClient] = useState(() => trpc.createClient({
        links: [
            httpBatchLink({
                url: API_URL,
            }),
        ],
    }));
    return (React.createElement(trpc.Provider, { client: trpcClient, queryClient: queryClient },
        React.createElement(QueryClientProvider, { client: queryClient }, children)));
};
